import { render, staticRenderFns } from "./CategorySection.vue?vue&type=template&id=a589ccfa&scoped=true"
import script from "./CategorySection.vue?vue&type=script&lang=js"
export * from "./CategorySection.vue?vue&type=script&lang=js"
import style0 from "./CategorySection.vue?vue&type=style&index=0&id=a589ccfa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a589ccfa",
  null
  
)

export default component.exports